import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack, useColorModeValue } from '@chakra-ui/react'
import { history } from '../../../../ApplicationRouter'
import { OrganizationForm } from '../../../../components/secure/dashboard/organization/OrganizationForm'
import { useTranslation } from 'react-i18next'

export const CreateOrganization = () => {
  const { t } = useTranslation();

  return (
    <AutoWidthCenter bg={useColorModeValue("bgPrimaryWhite", "bgPrimaryBlack")}>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">{t('Organization.Create')}</Heading>
          <Button onClick={() => history.back()}>{t('Return')}</Button>
        </HStack>
        <Divider />
        <OrganizationForm />
      </Box>
    </AutoWidthCenter >
  )
}